const siteTitle = 'Slutför din beställning';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Fyll i dina uppgifter',
    formTitle2: 'Du betalar här',
    btnForm: 'Fortsätt',
    btnForm2: 'Betala',
    priceText1: 'Betalning',
    priceText2: 'Totalt',
    footerTitle: 'Onlinebetalning',
    footerText: 'Bekräfta med ditt kreditkort',
  },
  home: {
    placeholder: {
      firstName: 'Namn',
      lastName: 'Efternamn',
      email: 'Email',
      phone: 'Telefon',
      city: 'Stad',
      address: 'Adress',
      zip: 'Postnummer',
      continue: 'Fortsättning',
      name: 'Namn',
    },
    confirmPayment: 'Bekräfta din betalning',
    cardNumber: 'kortnummer',
    expirationDate: 'Utgångsdatum',
    name: 'efternamn',
    month: 'månad',
    year: 'år',
    cvv: 'CVV',
  },
  validation: {
    requireEmail: 'Din e-postadress är tom',
    validEmail: 'E-postmeddelandet är inte giltigt',
    requirePhone: 'Din telefon är tom',
    minPhone: 'Telefonfältet måste innehålla minst tio tecken.',
    requireFirstName: 'Namnet krävs.',
    validFirstName: 'Förnamnet är inte giltigt.',
    requireLastName: 'Efternamnfältet krävs.',
    validLastName: 'Le champ Nom de famille est obligatoire.',
    requireCity: 'Le champ ville est obligatoire.',
    validCity: 'Stadsfältet är inte giltigt.',
    requireAddress: 'Adressfältet krävs.',
    validAddress: 'Adressfältet är inte giltigt.',
    requireZip: 'Postfältet krävs.',
    validZip: 'Zipfältet är ogiltigt.',
    requireCard: 'Kortnummerfältet krävs.',
    minCard: 'Inte tillräckligt med symboler.',
    validCard: 'Kortnummerfältet är inte giltigt.',
    requireMonth: 'Fältet för utgångs månad är obligatoriskt.',
    requireYear: 'Fältet Utgångsår är obligatoriskt.',
    requireName: 'Namnfältet krävs.',
    validName: 'Namnfältet är inte giltigt.',
    requireCvv: 'Cvv-fältet krävs.',
    validCvv: 'Cvv-fältet är inte giltigt.',
    minFirstName: 'Namnfältet måste innehålla minst tre tecken.',
    minLastName: 'Efternamnfältet måste innehålla minst tre tecken.',
    minCity: 'Stadsfältet måste innehålla minst tre tecken.',
    minAddress: 'Adressfältet måste innehålla minst 3 tecken.',
    minZip: 'Postnummerfältet måste innehålla minst 3 tecken.',
    minName: 'Namnfältet måste innehålla minst tre tecken.',
    minCvv: 'Cvv-fältet måste innehålla minst tre tecken.',
    specialFirstName: 'Fältnamnet får inte innehålla specialtecken',
    specialLastName: 'Fältets efternamn får inte innehålla specialtecken',
    specialName: 'Fältnamnet får inte innehålla specialtecken',
    specialCity: 'Stadsfältet får inte innehålla specialtecken',
  },
  mask: {
    phone: '+46 999 999 999',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'RICEVI IN TOCCO',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    email: 'E-mail',
    msg: 'Meddelande',
    send: 'Skicka',
    alreadyRegistered: 'Du är redan registrerad',
    unsubscribeLink: 'Du är redan registrerad',
    worktime: 'Call center Fungerar från 10 till 17',
    phone: 'Telefono: Sofia +359 2 437 4207',
  },
};
